import React from 'react';
import { TableVirtuoso } from 'react-virtuoso';
import { Icon, Dropdown, Menu, Button, Input, Tooltip, Checkbox, Spin, Tag } from 'antd';
import Moment from 'react-moment';
import moment from 'moment';
import { toBRL } from '~/components/UI/InputCurrency';
import { PERMISSIONS } from '~/constants/permissions.constants';
import Download from '~/components/Components/Download';
import { Status } from '~/components/UI';

var getExtraOrigin = function(extra) {
    if (extra && extra.certificate_id) {
        var certType = extra.certificate && extra.certificate.type ? extra.certificate.type : '';
        return { label: 'Certificado', sublabel: certType, color: '#1890ff' };
    }
    if (extra && extra.dash_task_id) {
        var category = extra.dashtask && extra.dashtask.category;
        switch (parseInt(category)) {
            case 1: return { label: 'Abertura', color: '#52c41a' };
            case 2: return { label: 'Alteração', color: '#faad14' };
            case 3: return { label: 'Encerramento', color: '#f5222d' };
            case 4: return { label: 'Tarefa', color: '#722ed1' };
            case 5: return { label: 'Troca (entrada)', color: '#13c2c2' };
            case 6: return { label: 'Outros', color: '#8c8c8c' };
            case 7: return { label: 'Troca (saída)', color: '#eb2f96' };
            default: return { label: 'Societário', color: '#595959' };
        }
    }
    return { label: 'Manual', color: '#d9d9d9' };
};

var payment_method = function(val) {
    switch (val) {
        case 1: return 'Dinheiro';
        case 2: return 'Boleto';
        case 3: return 'Cartão';
        case 4: return 'Transferência';
        case 5: return 'Pix';
        case 6: return 'Depósito';
        case 7: return 'Cheque';
        default: return '';
    }
};

var COL = {
    check: 40, status: 90, soc: 90, name: 220, task: 180, origin: 110,
    quota: 60, method: 80, apuration: 95, due: 95, paid_at: 95,
    amount: 90, balance: 90, actions: 75
};
var TABLE_W = Object.keys(COL).reduce(function(s, k) { return s + COL[k]; }, 0);

var thBase = {
    padding: '8px 12px', background: '#fafafa',
    borderTop: '1px solid #e8e8e8', borderBottom: '1px solid #e8e8e8',
    borderRight: '1px solid #e8e8e8',
    fontWeight: 500, textAlign: 'left', whiteSpace: 'nowrap',
    overflow: 'hidden', textOverflow: 'ellipsis', fontSize: 13
};
var tdBase = {
    padding: '8px 12px', background: '#fff',
    borderBottom: '1px solid #e8e8e8', borderRight: '1px solid #e8e8e8',
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 13
};

var stickyLeftTh = { position: 'sticky', left: 0, zIndex: 3, borderLeft: '1px solid #e8e8e8' };
var stickyRightTh = { position: 'sticky', right: 0, zIndex: 3, boxShadow: '-3px 0 6px rgba(0,0,0,0.06)' };
var stickyLeftTd = { position: 'sticky', left: 0, zIndex: 2, borderLeft: '1px solid #e8e8e8' };
var stickyRightTd = { position: 'sticky', right: 0, zIndex: 2, boxShadow: '-3px 0 6px rgba(0,0,0,0.06)' };

var socStyle = {
    fontSize: 12, background: '#f2f2f2', padding: '1px 5px',
    borderRadius: 5, border: 'solid 1px #ccc', whiteSpace: 'nowrap'
};

function thS(w, extra) { return Object.assign({}, thBase, { minWidth: w }, extra); }
function tdS(w, extra) { return Object.assign({}, tdBase, { minWidth: w }, extra); }

var SORTERS = {
    soc: function(a, b) {
        var sa = a.extra && a.extra.dash_task_id || 0;
        var sb = b.extra && b.extra.dash_task_id || 0;
        return sa - sb;
    },
    name: function(a, b) {
        var ca = (a.customer && a.customer.cod || '').toString();
        var cb = (b.customer && b.customer.cod || '').toString();
        var c = ca.localeCompare(cb);
        if (c !== 0) return c;
        return (a.customer && a.customer.name || '').localeCompare(b.customer && b.customer.name || '');
    },
    apuration_at: function(a, b) {
        var aa = a.extra && a.extra.apuration_at || '';
        var bb = b.extra && b.extra.apuration_at || '';
        return aa.localeCompare(bb);
    },
    due_date: function(a, b) { return (a.due_date || '').localeCompare(b.due_date || ''); },
    paid_at: function(a, b) { return (a.paid_at || '').localeCompare(b.paid_at || ''); },
    amount: function(a, b) { return (a.amount || 0) - (b.amount || 0); },
    balance: function(a, b) {
        var balA = (parseFloat(a.amount) || 0) - (parseFloat(a.paid) || 0);
        var balB = (parseFloat(b.amount) || 0) - (parseFloat(b.paid) || 0);
        return balA - balB;
    }
};

var ExtrasTableList = React.memo(function ExtrasTableList(props) {
    var isLoading = props.isLoading;
    var filteredData = props.filteredData;
    var rowSelection = props.rowSelection;
    var user = props.user;
    var onAction = props.onAction;
    var getFilename = props.getFilename;
    var parentStatusFilters = props.statusFilters || [];
    var parentOriginFilters = props.originFilters || [];

    var sortState = React.useState('name');
    var sortField = sortState[0]; var setSortField = sortState[1];
    var orderState = React.useState('ascend');
    var sortOrder = orderState[0]; var setSortOrder = orderState[1];
    var statusState = React.useState(null);
    var statusFilter = statusState[0]; var setStatusFilter = statusState[1];
    var originState = React.useState(null);
    var originFilter = originState[0]; var setOriginFilter = originState[1];
    var empState = React.useState('');
    var empFilter = empState[0]; var setEmpFilter = empState[1];
    var empInputState = React.useState('');
    var empInput = empInputState[0]; var setEmpInput = empInputState[1];
    var empOpenState = React.useState(false);
    var empOpen = empOpenState[0]; var setEmpOpen = empOpenState[1];

    var processedData = React.useMemo(function() {
        var src = filteredData || [];
        // Merge parent + local filters
        var effectiveStatusFilters = parentStatusFilters.length > 0 ? parentStatusFilters : (statusFilter ? [statusFilter] : []);
        var effectiveOriginFilters = parentOriginFilters.length > 0 ? parentOriginFilters : (originFilter ? [originFilter] : []);
        var hasStatus = effectiveStatusFilters.length > 0;
        var hasOrigin = effectiveOriginFilters.length > 0;
        var hasEmp = !!empFilter;
        var ef = hasEmp ? empFilter.toLowerCase() : '';

        var originCategoryMap = { abertura: 1, alteracao: 2, encerramento: 3, tarefa: 4, troca_entrada: 5, outros: 6, troca_saida: 7 };

        var result;
        if (!hasStatus && !hasOrigin && !hasEmp) {
            result = src;
        } else {
            result = [];
            for (var i = 0, len = src.length; i < len; i++) {
                var r = src[i];
                if (hasStatus && effectiveStatusFilters.indexOf(r.status) === -1) continue;
                if (hasOrigin) {
                    var cat = r.extra && r.extra.dashtask && r.extra.dashtask.category ? parseInt(r.extra.dashtask.category) : 0;
                    var hasCert = r.extra && r.extra.certificate_id;
                    var hasDash = r.extra && r.extra.dash_task_id;
                    var matched = false;
                    for (var j = 0; j < effectiveOriginFilters.length; j++) {
                        var of = effectiveOriginFilters[j];
                        if (of === 'certificate' && hasCert) { matched = true; break; }
                        if (of === 'manual' && !hasCert && !hasDash) { matched = true; break; }
                        if (originCategoryMap[of] && hasDash && cat === originCategoryMap[of]) { matched = true; break; }
                    }
                    if (!matched) continue;
                }
                if (hasEmp) {
                    var nameMatch = r.customer && r.customer.name && r.customer.name.toLowerCase().indexOf(ef) !== -1;
                    var codMatch = r.customer && r.customer.cod && r.customer.cod.toLowerCase().indexOf(ef) !== -1;
                    if (!nameMatch && !codMatch) continue;
                }
                result.push(r);
            }
        }

        if (sortField && SORTERS[sortField]) {
            result = result.slice().sort(SORTERS[sortField]);
            if (sortOrder === 'descend') result.reverse();
        }
        return result;
    }, [filteredData, parentStatusFilters, parentOriginFilters, statusFilter, originFilter, empFilter, sortField, sortOrder]);

    function toggleSort(field) {
        if (sortField === field) {
            if (sortOrder === 'ascend') { setSortOrder('descend'); }
            else { setSortField(null); setSortOrder(null); }
        } else {
            setSortField(field); setSortOrder('ascend');
        }
    }

    function sortIcon(field) {
        if (sortField !== field) return <Icon type="caret-down" style={{ marginLeft: 4, fontSize: 10, opacity: 0.3 }} />;
        return <Icon type={sortOrder === 'ascend' ? 'caret-up' : 'caret-down'} style={{ marginLeft: 4, fontSize: 10, color: '#1890ff' }} />;
    }

    var selectedKeys = rowSelection.selectedRowKeys;
    var selectedKeysSet = React.useMemo(function() { return new Set(selectedKeys); }, [selectedKeys]);
    var allChecked = processedData.length > 0 && selectedKeys.length === processedData.length;
    var someChecked = selectedKeys.length > 0 && !allChecked;

    function onToggleAll(e) {
        if (e.target.checked) {
            rowSelection.onChange(processedData.map(function(r) { return r.id; }));
        } else {
            rowSelection.onChange([]);
        }
    }
    function onToggleRow(id) {
        var idx = selectedKeys.indexOf(id);
        if (idx === -1) { rowSelection.onChange(selectedKeys.concat([id])); }
        else { rowSelection.onChange(selectedKeys.filter(function(k) { return k !== id; })); }
    }

    function searchFilterDropdown() {
        return (
            <Dropdown
                visible={empOpen}
                onVisibleChange={setEmpOpen}
                trigger={['click']}
                overlay={
                    <div style={{ padding: 8, background: 'white', boxShadow: '0 2px 8px rgba(0,0,0,.15)', borderRadius: 4 }}
                         onClick={function(e) { e.stopPropagation(); }}>
                        <Input
                            placeholder="Filtrar por empresa"
                            value={empInput}
                            onChange={function(e) { setEmpInput(e.target.value); }}
                            onPressEnter={function() { setEmpFilter(empInput); setEmpOpen(false); }}
                            style={{ width: 250, marginBottom: 8, display: 'block' }}
                        />
                        <Button type="primary" onClick={function() { setEmpFilter(empInput); setEmpOpen(false); }}
                            icon="search" size="small" style={{ width: 120, marginRight: 8 }}>
                            Pesquisar
                        </Button>
                        <Button onClick={function() { setEmpFilter(''); setEmpInput(''); setEmpOpen(false); }}
                            size="small" style={{ width: 120 }}>
                            Resetar
                        </Button>
                    </div>
                }
            >
                <Icon type="search"
                    onClick={function(e) { e.stopPropagation(); }}
                    style={{ marginLeft: 4, color: empFilter ? '#1890ff' : '#bfbfbf', cursor: 'pointer', fontSize: 12 }}
                />
            </Dropdown>
        );
    }

    var dataRef = React.useRef({});
    dataRef.current = { processedData: processedData };

    var tableComponents = React.useMemo(function() {
        return {
            Table: function(p) {
                return <table {...p} style={Object.assign({}, p.style, {
                    borderCollapse: 'separate', borderSpacing: 0, tableLayout: 'fixed', width: '100%', minWidth: TABLE_W
                })} />;
            },
            TableRow: function(p) {
                var d = dataRef.current;
                var record = d.processedData[p['data-item-index']];
                var rowStyle = {};
                if (record && record.extra && !record.extra.revised) {
                    rowStyle = { background: '#fffbe6' };
                }
                return <tr {...p} style={Object.assign({}, p.style, rowStyle)} className={'row-clabs' + (p.className ? ' ' + p.className : '')} />;
            }
        };
    }, []);

    var fixedHeaderContent = React.useCallback(function() {
        return (
            <tr>
                <th style={thS(COL.check, Object.assign({ textAlign: 'center' }, stickyLeftTh))}>
                    <Checkbox checked={allChecked} indeterminate={someChecked} onChange={onToggleAll} />
                </th>
                <th style={thS(COL.status)}>
                    Status
                    <Dropdown trigger={['click']} overlay={
                        <Menu onClick={function(e) { setStatusFilter(e.key === 'all' ? null : e.key); }}>
                            <Menu.Item key="all">Todos</Menu.Item>
                            <Menu.Divider />
                            <Menu.Item key="Pago">Pago</Menu.Item>
                            <Menu.Item key="Pendente">Pendente</Menu.Item>
                            <Menu.Item key="Inadimplente">Inadimplente</Menu.Item>
                            <Menu.Item key="Ajuizado">Ajuizado</Menu.Item>
                        </Menu>
                    }>
                        <Icon type="filter" style={{ marginLeft: 4, color: statusFilter ? '#1890ff' : '#bfbfbf', cursor: 'pointer' }} />
                    </Dropdown>
                </th>
                <th style={thS(COL.soc, { cursor: 'pointer' })} onClick={function() { toggleSort('soc'); }}>
                    SOC {sortIcon('soc')}
                </th>
                <th style={thS(COL.name, { cursor: 'pointer' })} onClick={function() { toggleSort('name'); }}>
                    Empresa {sortIcon('name')} {searchFilterDropdown()}
                </th>
                <th style={thS(COL.task)}>Tarefa</th>
                <th style={thS(COL.origin)}>
                    Origem
                    <Dropdown trigger={['click']} overlay={
                        <Menu onClick={function(e) { setOriginFilter(e.key === 'all' ? null : e.key); }}>
                            <Menu.Item key="all">Todos</Menu.Item>
                            <Menu.Divider />
                            <Menu.Item key="abertura">Abertura</Menu.Item>
                            <Menu.Item key="alteracao">Alteração</Menu.Item>
                            <Menu.Item key="encerramento">Encerramento</Menu.Item>
                            <Menu.Item key="tarefa">Tarefa</Menu.Item>
                            <Menu.Item key="troca_entrada">Troca (entrada)</Menu.Item>
                            <Menu.Item key="troca_saida">Troca (saída)</Menu.Item>
                            <Menu.Item key="outros">Outros</Menu.Item>
                            <Menu.Divider />
                            <Menu.Item key="certificate">Certificado</Menu.Item>
                            <Menu.Item key="manual">Manual</Menu.Item>
                        </Menu>
                    }>
                        <Icon type="filter" style={{ marginLeft: 4, color: originFilter ? '#1890ff' : '#bfbfbf', cursor: 'pointer' }} />
                    </Dropdown>
                </th>
                <th style={thS(COL.quota)}>Parcela</th>
                <th style={thS(COL.method)}>Método</th>
                <th style={thS(COL.apuration, { cursor: 'pointer' })} onClick={function() { toggleSort('apuration_at'); }}>
                    Apuração {sortIcon('apuration_at')}
                </th>
                <th style={thS(COL.due, { cursor: 'pointer' })} onClick={function() { toggleSort('due_date'); }}>
                    Vencimento {sortIcon('due_date')}
                </th>
                <th style={thS(COL.paid_at, { cursor: 'pointer' })} onClick={function() { toggleSort('paid_at'); }}>
                    Data Pgto {sortIcon('paid_at')}
                </th>
                <th style={thS(COL.amount, { cursor: 'pointer' })} onClick={function() { toggleSort('amount'); }}>
                    Valor {sortIcon('amount')}
                </th>
                <th style={thS(COL.balance, { cursor: 'pointer' })} onClick={function() { toggleSort('balance'); }}>
                    Saldo {sortIcon('balance')}
                </th>
                <th style={thS(COL.actions, Object.assign({ textAlign: 'center' }, stickyRightTh))}>Ações</th>
            </tr>
        );
    }, [allChecked, someChecked, sortField, sortOrder, statusFilter, originFilter, empFilter]);

    function itemContent(index, record) {
        var isSelected = selectedKeysSet.has(record.id);
        var origin = getExtraOrigin(record.extra);
        var amount = parseFloat(record.amount) || 0;
        var paid = parseFloat(record.paid) || 0;
        var balance = amount - paid;

        return (
            <>
                <td style={tdS(COL.check, Object.assign({ textAlign: 'center' }, stickyLeftTd))}>
                    <Checkbox checked={isSelected} onChange={function() { onToggleRow(record.id); }} />
                </td>
                <td style={tdS(COL.status)}>
                    <Tooltip
                        placement="right"
                        title={
                            React.createElement('div', { style: { fontSize: 12, minWidth: 160 } },
                                React.createElement('div', { style: { fontWeight: 600, marginBottom: 6 } }, record.status),
                                React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', marginBottom: 3 } },
                                    React.createElement('span', { style: { color: 'rgba(255,255,255,0.7)' } }, 'Valor'),
                                    React.createElement('span', null, toBRL(amount))
                                ),
                                React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', marginBottom: 3 } },
                                    React.createElement('span', { style: { color: 'rgba(255,255,255,0.7)' } }, 'Pago'),
                                    React.createElement('span', { style: { color: '#95de64' } }, toBRL(paid))
                                ),
                                React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', borderTop: '1px solid rgba(255,255,255,0.15)', paddingTop: 4, marginTop: 2 } },
                                    React.createElement('span', { style: { color: 'rgba(255,255,255,0.7)' } }, 'Saldo'),
                                    React.createElement('span', { style: { fontWeight: 600, color: balance > 0 ? '#ff7875' : '#95de64' } }, toBRL(balance))
                                ),
                                record.extra && !record.extra.revised && React.createElement('div', { style: { marginTop: 6, padding: '3px 6px', background: 'rgba(250, 173, 20, 0.2)', borderRadius: 4, fontSize: 11, color: '#ffc53d' } }, 'Não revisado')
                            )
                        }
                    >
                        <span><Status value={record.status} /></span>
                    </Tooltip>
                </td>
                <td style={tdS(COL.soc)}>
                    {record.extra && record.extra.dash_task_id
                        ? <span style={socStyle}>#SOC{record.extra.dash_task_id}</span>
                        : ''}
                </td>
                <td style={tdS(COL.name)}>
                    {record.customer ? (
                        <span>
                            {record.customer.cod} - {record.customer.name && record.customer.name.length > 30
                                ? <Tooltip title={record.customer.name}>{record.customer.name.slice(0, 30) + '...'}</Tooltip>
                                : (record.customer.name || '')}
                        </span>
                    ) : ''}
                </td>
                <td style={tdS(COL.task)}>{record.extra && record.extra.task_name || ''}</td>
                <td style={tdS(COL.origin)}>
                    <Tag color={origin.color} style={{ margin: 0 }}>{origin.label}</Tag>
                </td>
                <td style={tdS(COL.quota)}>{record.quota}</td>
                <td style={tdS(COL.method)}>{payment_method(record.method)}</td>
                <td style={tdS(COL.apuration, { textAlign: 'center' })}>
                    {record.extra && record.extra.apuration_at && <Moment format="DD/MM/YYYY">{record.extra.apuration_at}</Moment>}
                </td>
                <td style={tdS(COL.due, { textAlign: 'center' })}>
                    {record.due_date && <Moment format="DD/MM/YYYY">{record.due_date}</Moment>}
                </td>
                <td style={tdS(COL.paid_at, { textAlign: 'center' })}>
                    {record.paid_at && <Moment format="DD/MM/YYYY">{record.paid_at}</Moment>}
                </td>
                <td style={tdS(COL.amount)}>{toBRL(amount)}</td>
                <td style={tdS(COL.balance)}>
                    <span style={{ color: balance > 0 ? '#f5222d' : '#52c41a' }}>{toBRL(balance)}</span>
                </td>
                <td style={tdS(COL.actions, Object.assign({ textAlign: 'center' }, stickyRightTd))}>
                    <span onClick={function(e) { e.stopPropagation(); }}>
                        <Dropdown overlay={
                            <Menu onClick={function(e) { onAction(e, record); }}>
                                {user.permissions.includes(PERMISSIONS.extraServices.edit) ?
                                    <Menu.Item key="edit"><Icon type="edit" /> Editar</Menu.Item>
                                :
                                    <Menu.Item key="edit"><Icon type="file" /> Detalhes</Menu.Item>
                                }
                                {record.paid_at === null && <Menu.Divider />}
                                {record.paid_at === null && (
                                    <Menu.Item key="paid"><Icon type="check" /> Marcar como Pago</Menu.Item>
                                )}
                                {record.status !== 'Pago' && record.status !== 'Inadimplente' && (
                                    <Menu.Item key="inadimplente"><Icon type="exclamation-circle" /> Marcar como inadimplente</Menu.Item>
                                )}
                                {record.status !== 'Pago' && record.status !== 'Ajuizado' && (
                                    <Menu.Item key="ajuizado"><Icon type="audit" /> Marcar como ajuizado</Menu.Item>
                                )}
                                {record.paid_at === null && <Menu.Divider />}
                                <Menu.Item>
                                    <Download url={'/extras/payments/print/' + record.id} filename={getFilename(record)}>
                                        <div><Icon style={{ minWidth: 12, marginRight: 8, fontSize: 12 }} type="printer" /> Imprimir</div>
                                    </Download>
                                </Menu.Item>
                            </Menu>
                        } trigger={['click']}>
                            <a className="ant-dropdown-link" href="#">Ações <Icon type="down" /></a>
                        </Dropdown>
                    </span>
                </td>
            </>
        );
    }

    if (!isLoading && processedData.length === 0) {
        var hasAnyFilter = !!statusFilter || !!originFilter || !!empFilter || parentStatusFilters.length > 0 || parentOriginFilters.length > 0;
        return (
            <div style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                padding: '60px 20px', background: '#fff', border: '1px solid #e8e8e8', borderRadius: 4,
            }}>
                <Icon
                    type={hasAnyFilter ? 'filter' : 'inbox'}
                    style={{ fontSize: 48, color: '#d9d9d9', marginBottom: 16 }}
                />
                <div style={{ fontSize: 16, color: '#595959', fontWeight: 500, marginBottom: 8 }}>
                    {hasAnyFilter ? 'Nenhum resultado encontrado' : 'Nenhum serviço extra'}
                </div>
                <div style={{ fontSize: 13, color: '#8c8c8c', textAlign: 'center', maxWidth: 320 }}>
                    {hasAnyFilter
                        ? 'Tente ajustar os filtros ou limpar a pesquisa para ver mais resultados.'
                        : 'Não há serviços extras cadastrados para o período selecionado.'}
                </div>
            </div>
        );
    }

    return (
        <Spin spinning={isLoading}>
            <TableVirtuoso
                style={{ height: 'calc(100vh - 280px)', border: '1px solid #e8e8e8' }}
                data={processedData}
                components={tableComponents}
                fixedHeaderContent={fixedHeaderContent}
                itemContent={itemContent}
                overscan={20}
            />
        </Spin>
    );
});

export default ExtrasTableList;
